/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GeneratedQueryMetadata } from "./GeneratedQueryMetadata";
export const GeneratedQuery = core.serialization.object({
    query: core.serialization.string(),
    queryType: core.serialization.string(),
    queryId: core.serialization.string(),
    metadata: GeneratedQueryMetadata,
});
